/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateAddressData
 */
export interface UpdateAddressData {
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressData
     */
    line1?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressData
     */
    line2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressData
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressData
     */
    region?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressData
     */
    postalCode?: string;
    /**
     * A 2-letter country code, must conform to ISO 3166-1 Alpha-2
     * @type {string}
     * @memberof UpdateAddressData
     */
    countryCode?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateAddressData
     */
    latitude?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAddressData
     */
    longitude?: number | null;
}

/**
 * Check if a given object implements the UpdateAddressData interface.
 */
export function instanceOfUpdateAddressData(value: object): value is UpdateAddressData {
    return true;
}

export function UpdateAddressDataFromJSON(json: any): UpdateAddressData {
    return UpdateAddressDataFromJSONTyped(json, false);
}

export function UpdateAddressDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAddressData {
    if (json == null) {
        return json;
    }
    return {
        
        'line1': json['line1'] == null ? undefined : json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'city': json['city'] == null ? undefined : json['city'],
        'region': json['region'] == null ? undefined : json['region'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
    };
}

  export function UpdateAddressDataToJSON(json: any): UpdateAddressData {
      return UpdateAddressDataToJSONTyped(json, false);
  }

  export function UpdateAddressDataToJSONTyped(value?: UpdateAddressData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'line1': value['line1'],
        'line2': value['line2'],
        'city': value['city'],
        'region': value['region'],
        'postalCode': value['postalCode'],
        'countryCode': value['countryCode'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
    };
}

